(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slideshow-email-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    // Klaviyo client subscriptions API revision. Update if Klaviyo retires it
    // (each revision is supported for 2 years after release).
    const KLAVIYO_REVISION = '2026-01-15';

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[data-klaviyo-signup]');

      if (!form) {
        return;
      }

      event.preventDefault();

      const wrapper = form.parentElement;
      const successBanner = wrapper.querySelector('[data-signup-success]');
      const errorBanner = wrapper.querySelector('[data-signup-error]');
      const submitButton = form.querySelector('[type="submit"]');
      const email = form.querySelector('input[name="email"]').value.trim();

      errorBanner.hidden = true;
      submitButton.setAttribute('aria-busy', 'true');

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  subscriptions: {
                    email: { marketing: { consent: 'SUBSCRIBED' } }
                  }
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: form.dataset.listId } }
          }
        }
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.companyId)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Klaviyo responded with ${response.status}`);
        }

        form.hidden = true;
        successBanner.hidden = false;
      } catch (error) {
        console.error(error);
        errorBanner.hidden = false;
      } finally {
        submitButton.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
